module.exports = __webpack_public_path__ + "b0fbfd8e70c54832b874dca16e12dde4.pdf";